import * as Types from '../generated/types';

import { gql } from '@apollo/client';
import { PageInfoFragmentDoc } from '../fragments/pageInfo.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AllBanksQueryVariables = Types.Exact<{
  offset?: Types.InputMaybe<Types.Scalars['Int']>;
  before?: Types.InputMaybe<Types.Scalars['String']>;
  after?: Types.InputMaybe<Types.Scalars['String']>;
  first?: Types.InputMaybe<Types.Scalars['Int']>;
  last?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type AllBanksQuery = { __typename?: 'Query', allBanks?: { __typename?: 'BankNodeConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'BankNodeEdge', cursor: string, node?: { __typename?: 'BankNode', id: string, name: string } | null } | null> } | null };


export const AllBanksDocument = gql`
    query AllBanks($offset: Int, $before: String, $after: String, $first: Int, $last: Int) {
  allBanks(
    offset: $offset
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    pageInfo {
      ...PageInfo
    }
    edges {
      node {
        id
        name
      }
      cursor
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useAllBanksQuery__
 *
 * To run a query within a React component, call `useAllBanksQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllBanksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllBanksQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useAllBanksQuery(baseOptions?: Apollo.QueryHookOptions<AllBanksQuery, AllBanksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllBanksQuery, AllBanksQueryVariables>(AllBanksDocument, options);
      }
export function useAllBanksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllBanksQuery, AllBanksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllBanksQuery, AllBanksQueryVariables>(AllBanksDocument, options);
        }
export type AllBanksQueryHookResult = ReturnType<typeof useAllBanksQuery>;
export type AllBanksLazyQueryHookResult = ReturnType<typeof useAllBanksLazyQuery>;
export type AllBanksQueryResult = Apollo.QueryResult<AllBanksQuery, AllBanksQueryVariables>;